import TOLGEE_GLOBALS from './tolgeeGlobals'

export const getMonthNumberFromString = (baseMonth: string) => {
  const month = baseMonth.toLocaleLowerCase()
  if (['jan', 'ene'].includes(month)) {
    return '01'
  }
  if (['feb', 'fev'].includes(month)) {
    return '02'
  }
  if (['mar'].includes(month)) {
    return '03'
  }
  if (['abr', 'apr'].includes(month)) {
    return '04'
  }
  if (['mai', 'may'].includes(month)) {
    return '05'
  }
  if (['jun'].includes(month)) {
    return '06'
  }
  if (['jul'].includes(month)) {
    return '07'
  }
  if (['aug', 'ago'].includes(month)) {
    return '08'
  }
  if (['sep', 'set'].includes(month)) {
    return '09'
  }
  if (['out', 'oct'].includes(month)) {
    return '10'
  }
  if (['nov'].includes(month)) {
    return '11'
  }
  if (['dec', 'dez'].includes(month)) {
    return '12'
  }
}

/**
 * Expected to work with te format "Last [value] [period]" ie: "Last 3 months"
 */
export const getTolgeeDateFromString = (text: string, t) => {
  if (text.includes('24')) {
    return t(TOLGEE_GLOBALS.last24hours)
  }
  if (text.includes('30')) {
    return t(TOLGEE_GLOBALS.lastThirtyDays)
  }
  if (text.includes('3') && text.includes('m')) {
    return t(TOLGEE_GLOBALS.lastThreeMonths)
  }
  if (text.includes('3')) {
    return t(TOLGEE_GLOBALS.lastThreeYears)
  }
  if (text.includes('7')) {
    return t(TOLGEE_GLOBALS.lastSevenDays)
  }
  if (text.includes('6')) {
    return t(TOLGEE_GLOBALS.lastSixMonths)
  }
  if (text.includes('12')) {
    return t(TOLGEE_GLOBALS.lastTwelveMonths)
  }
  if (text.includes('2')) {
    return t(TOLGEE_GLOBALS.lastTwoYears)
  }
  return t(TOLGEE_GLOBALS.lastTwelveMonths)
}
